"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const chooseLocationContext_1 = require("../chooseLocationContext");
const context_1 = require("../../../context");
const app_1 = require("app");
const LanguageLink = () => {
    const { state } = (0, chooseLocationContext_1.useChooseLocationContext)();
    const { firstLineData: { currentCountry }, } = React.useContext(context_1.HeaderContext);
    const { selectedLanguageUrl, dictionary } = state;
    const isLanguageLinkDisabled = React.useMemo(() => {
        return !!(selectedLanguageUrl && selectedLanguageUrl === currentCountry.url);
    }, [currentCountry.url, selectedLanguageUrl]);
    return ((0, jsx_runtime_1.jsx)("div", { className: "mt-md flex justify-end", children: (0, jsx_runtime_1.jsx)("a", { id: "go-to-site", href: selectedLanguageUrl, className: (0, app_1.cn)('btn-primary no-underline', isLanguageLinkDisabled &&
                'header-locations__link--disabled bg-df-gray-light pointer-events-none border-df-gray-light'), children: dictionary.locationLinkLabel }) }));
};
exports.default = LanguageLink;
